<template>
  <div class="cart">
    <h1 class="boxTitle mb15 notranslate toUppercase">{{locale.cart}}</h1>
    <CartList
      :lang="lang"
      :locale="locale"
      :isPublic="isPublic" />
  </div>
</template>

<script>
import CartList from '@/components/Cart/CartList.vue'

export default {
  name: 'Cart',
  props: [
    'locale',
    'isPublic',
    'lang'
  ],
  components: {
    CartList
  },
  mounted () {
    this.track()
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'cart'
      })
    }
  }
}
</script>
